import React, { useState, useEffect, useRef } from "react";
import { ofishlogo } from "../../../resources/images/index";
import {
  Settings,
  Notification,
  Help,
  Calendar,
} from "../../../ofishadmin/views/LeftNav/SvgIcons";
import { useDispatch, useSelector } from "react-redux";
import { Dropdown } from "../../common";
import { Button } from "@material-ui/core";
import OutsideClickHandler from "react-outside-click-handler";
import { useHistory } from "react-router-dom";
import Cookies from "js-cookie";
import { accountActions } from "../../../store/accounts/accountActions";
import FroalaEditorView from "react-froala-wysiwyg/FroalaEditorView";
import MarkunreadIcon from "@mui/icons-material/Markunread";
import DraftsIcon from "@mui/icons-material/Drafts";
import moment from "moment";
import Loader from "../Loader";
import OutlookLoginButton from "../OutlookLoginButton";

function DashboardHeader(props) {
  const dispatch = useDispatch();
  const { notificationData } = useSelector(state => state.AccountReducer);
  const [isLogout, setIsLogout] = useState(false);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [showNotiMenu, setShowNotiMenu] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const modalRef = useRef();

  const history = useHistory();
  useEffect(() => {
    const fName = localStorage.getItem("name");
    const lName = localStorage.getItem("lName");
    const userId = localStorage.getItem("id");
    setFirstName(fName);
    setLastName(lName);
    dispatch(accountActions.onGetNotification(userId));
  }, []);

  const redirect = () => {
    history.push("/");
  };
  const onClickNotification = data => {
    const userId = localStorage.getItem("id");
    dispatch(
      accountActions.onMarkNotificationRead({
        id: data.id,
        isRead: true,
      }),
    ).then(res => {
      dispatch(accountActions.onGetNotification(userId));
    });
    setShowNotiMenu(false);
    if (data?.notificationType === "Chat") {
      history.push("/conversations-list");
    } else if (data?.notificationType === "Prospect") {
      history.push("/prospect-generation");
    }
  };
  const onClickNotificationIcon = () => {
    const userId = localStorage.getItem("id");
    if (showNotiMenu === false) {
      setIsLoading(true);
      dispatch(accountActions.onGetNotification(userId)).then(res => {
        setIsLoading(false);
        setShowNotiMenu(true);
      });
    } else {
      setShowNotiMenu(false);
    }
  };

  // Handle logout - clear both Microsoft and regular auth
  const handleCompleteLogout = () => {
    // Check if Microsoft auth exists
    const microsoftUser = localStorage.getItem("microsoft_user");
    if (microsoftUser) {
      // Clear Microsoft auth data
      localStorage.removeItem("microsoft_user");
      localStorage.removeItem("microsoft_token");
      localStorage.removeItem("authProvider");
    }
    // Clear existing auth
    localStorage.removeItem("access_token");
    localStorage.removeItem("isAuthenticated");
    localStorage.removeItem("userEmail");
    localStorage.removeItem("isAdmin");
    localStorage.removeItem("name");
    localStorage.removeItem("lName");
    localStorage.removeItem("id");
    localStorage.removeItem("isShowProspect");
    Cookies.remove("access_token");

    redirect();
  };

  return (
    <div className='dashboardHeaderWrapper'>
      {isLoading && <Loader />}
      <div className='leftNavLogo'>
        <img src={ofishlogo} alt='' />
        <span>
          <Dropdown value='' placeholder='Aquatic AV' />
        </span>
      </div>
      <div className='headerRight'>
        <span>
          <input
            type='text'
            placeholder='Search product name, SKU, serials, orders and more'
          />
        </span>
        <span className='DashboardHeaderIcons'>
          {/* <span onClick={() => history.push("/calendarview")}>
            <Calendar />
          </span> */}

          <OutsideClickHandler onOutsideClick={() => setShowNotiMenu(false)}>
            <span
              className='notificationIcon'
              onClick={() => onClickNotificationIcon()}>
              {notificationData?.unRead > 0 && (
                <div className='notIcon'>{notificationData?.unRead}</div>
              )}
              <Notification />
            </span>
            {showNotiMenu && (
              <div className='notifactionMenu notificatioWrap'>
                {notificationData?.data?.length > 0 ? (
                  <>
                    {notificationData?.data.map(item => (
                      <div
                        key={item.Id}
                        className='notificationBody'
                        onClick={() => {
                          onClickNotification(item);
                        }}>
                        <div className='notificationIcons'>
                          {item.isRead ? <DraftsIcon /> : <MarkunreadIcon />}
                        </div>
                        <div className='notiCenterBody'>
                          <span
                            className='notifcationTitle'
                            style={{
                              fontWeight: `${item.isRead ? "normal" : "bold"}`,
                            }}>
                            {item.notificationTitle}
                          </span>
                          <span className='notificationDetail'>
                            <FroalaEditorView
                              model={item.notificationContent?.substring(0, 40)}
                            />
                          </span>
                          <span className='notiDateTime'>
                            {`${moment(item?.createdOn).format("dddd")}, 
                                          ${moment(item?.createdOn).format(
                                            "l",
                                          )} @ ${moment(item?.createdOn).format(
                                            "h:mm a",
                                          )} `}
                          </span>
                        </div>
                      </div>
                    ))}
                  </>
                ) : (
                  <div className='notificationBody'>
                    <span
                      className='notificationDetail'
                      style={{ alignSelf: "center" }}>
                      You don't have any latest notification(s)
                    </span>
                  </div>
                )}
              </div>
            )}
          </OutsideClickHandler>

          {/* <Help /> */}
          <span>Hi, {lastName} </span>
          <OutsideClickHandler onOutsideClick={() => setIsLogout(false)}>
            <span className='circleName' onClick={() => setIsLogout(!isLogout)}>
              {`${firstName?.charAt(0).toUpperCase()}${lastName
                ?.charAt(0)
                .toUpperCase()}`}
              {isLogout && (
                <span className='logoutDropdown'>
                  <Button
                    onClick={() => {
                      history.push("/");
                    }}>
                    Newsroom
                  </Button>
                  <OutlookLoginButton />
                  <Button onClick={() => handleCompleteLogout()}>Logout</Button>
                </span>
              )}
            </span>
          </OutsideClickHandler>
        </span>
      </div>
    </div>
  );
}

export default DashboardHeader;
